import { camelCase } from '../_utilities/changeCaseMirror.js';
import cx from 'classnames';
import React, { useMemo } from 'react';
export const IconFragmentElement = ({ child, ...rest }) => {
    const { attributes, children, name, type } = child;
    if (type !== 'element') {
        return null;
    }
    // if type === 'element', it will always be that & this will never be called,
    // Moving it up to obey the rule would just waste energy
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const formattedAttributes = useMemo(() => Object.assign({}, ...Object.entries(attributes).map(([k, v]) => ({
        [camelCase(k)]: v,
    }))), [attributes]);
    const ElementName = name;
    return (React.createElement(ElementName, { ...formattedAttributes, ...rest }, children && children.map((child, i) => React.createElement(IconFragmentElement, { child: child, key: i }))));
};
export const IconFragment = ({ data, ...rest }) => {
    const { children } = data;
    return (React.createElement(React.Fragment, null, children.map((child, i) => (React.createElement(IconFragmentElement, { child: child, key: i, ...rest })))));
};
/**
 * Icon Component
 * @param data pass an icon data object from `design-system-icons`
 *
 * Renders an Icon component from Design System Icons
 *
 * Example: `<Icon data={iconStatusSuccess}/>`
 */
export const Icon = ({ align, children, className, color, data, description, inline, style, size, title, viewBox, ...rest }) => (React.createElement("svg", { className: cx('tds-icon', { 'tds-icon--inline': inline }, { [`tds-${data && data.id}`]: data }, { 'tds-icon--small': data && data.id.includes('small') }, { [`tds-icon--${align}`]: align }, { [`tds-icon--${size}`]: size }, className), style: { ...style, color }, viewBox: (data === null || data === void 0 ? void 0 : data.viewBox) || viewBox || '0 0 24 24', xmlns: "http://www.w3.org/2000/svg", ...rest },
    title && React.createElement("title", null, title),
    description && React.createElement("desc", null, description),
    data && React.createElement(IconFragment, { data: data }),
    children && children));
